'use strict'

import React from 'react'
import PropTypes from 'prop-types'
import NumberFormatter from 'nmc-number-formatter'

const numberFormatter = new NumberFormatter()
numberFormatter.addStyle('nmc-abbreviation', ['K', 'MM', 'B', 'T'])
numberFormatter.setDefaultStyle('nmc-abbreviation')

const LETTERS_TO_UNITS = {
  'K': 'thousand',
  'MM': 'million',
  'B': 'billion',
  'T': 'trillion'
}

/**
 * Returns a number to divide with
 * @param {String|Number} input - the number. it could be a string that indicates the unit (thousand, million, etc.),
 * it can be the abbreviation we use or it could be an actual number.
 * @returns {Number}
 */
const getDivider = (input) => {
  if (LETTERS_TO_UNITS.hasOwnProperty(input)) {
    return NumberFormatter.getDivider(LETTERS_TO_UNITS[input])
  }
  const value = parseInt(input, 10)
  // if there is no numeric meaning in the string, we try to parse it with getDivider
  return isNaN(value) ? NumberFormatter.getDivider(input) : value
}

/**
 * Returns a unit's name by it's abbreviation symbol if there is one - it will pass the argument as it is otherwise
 * @param {String} unit - a string represent a unit
 * @returns {String}
 */
const parseUnit = (unit) => {
  return LETTERS_TO_UNITS[unit]
}

class NumberFormat extends React.Component {
  /**
   * Returns the component's content as an integer
   * @returns {Number}
   */
  getNumericContent () {
    return parseInt(this.props.children, 10)
  }

  /**
   * Returns true if the input number is smaller than the floor limit (if there is one)
   * @returns {Boolean}
   */
  isBelowFloorLimit () {
    const {floor} = this.props
    if (floor) {
      const floorLimit = getDivider(floor)
      return this.getNumericContent() < floorLimit
    }
    return false
  }

  /**
   * Returns the formatted number by the properties
   * @returns {String}
   */
  getFormattedContent () {
    const num = this.getNumericContent()
    if (typeof num !== 'number' || Number.isNaN(num)) {
      return ''
    }
    const {precision} = this.props
    const measurement = this.props.measurement ? parseUnit(this.props.measurement) : null
    return this.isBelowFloorLimit() ? num : numberFormatter.format(num, {measurement, precision})
  }

  render () {
    return <span>{this.getFormattedContent()}</span>
  }
}

NumberFormat.propTypes = {
  measurement: PropTypes.oneOf(['thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'K', 'MM', 'B', 'T']),
  precision: PropTypes.number,
  floor: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}
NumberFormat.defaultProps = {
  floor: 0
}

export default NumberFormat



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/NumberFormat/index.js